const BOLETO_CANCEL_STEPS_ENUM = {
  REFUND_TYPE: 'REFUND_TYPE_STEP',
  BANK_DETAILS: 'BANK_DETAILS_STEP',
  CONFIRM_BANK_DETAILS: 'CONFIRM_BANK_DETAILS_STEP',
  ERROR: 'ERROR'
}

const isRefundTypeStep = type =>
  type.toLowerCase() === BOLETO_CANCEL_STEPS_ENUM.REFUND_TYPE.toLowerCase()
const isBankDetailsStep = type =>
  type.toLowerCase() === BOLETO_CANCEL_STEPS_ENUM.BANK_DETAILS.toLowerCase()
const isConfirmBankDetailsStep = type =>
  type.toLowerCase() ===
  BOLETO_CANCEL_STEPS_ENUM.CONFIRM_BANK_DETAILS.toLowerCase()
const isErrorStep = type =>
  type.toLowerCase() === BOLETO_CANCEL_STEPS_ENUM.ERROR.toLowerCase()

export {
  BOLETO_CANCEL_STEPS_ENUM,
  isBankDetailsStep,
  isRefundTypeStep,
  isConfirmBankDetailsStep,
  isErrorStep
}
